import Swiper, { Autoplay, Navigation, Grid, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

/* =========================
   HELPERS
========================= */

// NEW: debounce
function debounce(fn, delay = 150) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}

function getMetricsRowsThreshold() {
  return window.innerWidth >= 769 ? 5 : 4;
}

function shouldUseTwoMetricsRows(slidesCount) {
  return slidesCount >= getMetricsRowsThreshold();
}

function getMetricsRowsCount(slidesCount) {
  return shouldUseTwoMetricsRows(slidesCount) ? 2 : 1;
}

function getMetricsBreakpoints(slidesCount) {
  const mobileRows = slidesCount >= 4 ? 2 : 1;
  const desktopRows = slidesCount >= 5 ? 2 : 1;

  return {
    641: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 20,
      grid: {
        rows: mobileRows,
        fill: 'row',
      },
    },
    769: {
      slidesPerView: desktopRows === 2 ? 2 : 3,
      slidesPerGroup: desktopRows === 2 ? 2 : 3,
      spaceBetween: 20,
      grid: {
        rows: desktopRows,
        fill: 'row',
      },
    },
    850: {
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 20,
      grid: {
        rows: desktopRows,
        fill: 'row',
      },
    },
    1023: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 20,
      grid: {
        rows: desktopRows,
        fill: 'row',
      },
    },
    1200: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 24,
      grid: {
        rows: desktopRows,
        fill: 'row',
      },
    },
  };
}

function updateWrapperJustifyState(wrapper) {
  if (!wrapper) return;

  wrapper.scrollWidth >= wrapper.clientWidth
      ? wrapper.classList.remove('justify-center')
      : wrapper.classList.add('justify-center');
}

function resetSlidesMinHeight(slides) {
  slides.forEach((slide) => {
    slide.style.minHeight = '';
  });
}

function updateSlidesMinHeight(slides) {
  if (!slides.length) return;

  resetSlidesMinHeight(slides);

  const maxSlideHeight = Math.max(
      ...Array.from(slides, (slide) => Math.ceil(slide.getBoundingClientRect().height)),
      0
  );

  slides.forEach((slide) => {
    slide.style.minHeight = maxSlideHeight ? `${maxSlideHeight}px` : '';
  });
}

function applyWrapperMaxHeight(wrapper, slides, rowsCount) {
  if (!wrapper) return;

  if (rowsCount !== 2 || !shouldUseTwoMetricsRows(slides.length)) {
    wrapper.style.maxHeight = '';
    return;
  }

  const maxSlideHeight = Math.max(
      ...Array.from(slides, (slide) => Math.ceil(slide.getBoundingClientRect().height)),
      0
  );
  wrapper.style.maxHeight = maxSlideHeight ? `${maxSlideHeight * 2 + 80}px` : '';
}

function syncMetricsLayout(swiperEl, wrapper, slides) {
  const rowsCount = getMetricsRowsCount(slides.length);

  swiperEl.classList.toggle('swiper-grid-type', rowsCount === 2);
  updateSlidesMinHeight(slides);

  requestAnimationFrame(() => {
    updateWrapperJustifyState(wrapper);
    applyWrapperMaxHeight(wrapper, slides, rowsCount);
  });
}

let metricsSwiperWr = document.querySelectorAll('.metrics-swiper-wr');
metricsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let paginationEl = el.querySelector('.swiper-pagination');
    let slides = el.querySelectorAll('.swiper-slide');
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    let slidesCount = slides.length;

    const debouncedSyncMetricsLayout = debounce(() => {
      syncMetricsLayout(swiperEl, wrapper, slides);
    }, 150);

    swiperEl.classList.add(`slides-length-${slides.length}`);
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Grid, Pagination],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 20,
      slidesPerView: 1,
      grid: {
        rows: getMetricsRowsCount(slidesCount),
        fill: 'row',
      },
      speed: 600,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: getMetricsBreakpoints(slidesCount),
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
      on: {
        afterInit() {
          syncMetricsLayout(swiperEl, wrapper, slides);

          setTimeout(() => {
            syncMetricsLayout(swiperEl, wrapper, slides);
          }, 100);
        },
        resize() {
          debouncedSyncMetricsLayout();
        },
        breakpoint() {
          debouncedSyncMetricsLayout();
        },
      },
    });
    swiperObserver(swiper);

  }
});
